import { render, staticRenderFns } from "./pickup-goods.vue?vue&type=template&id=28616c25&scoped=true&"
import script from "./pickup-goods.vue?vue&type=script&lang=js&"
export * from "./pickup-goods.vue?vue&type=script&lang=js&"
import style0 from "./pickup-goods.vue?vue&type=style&index=0&id=28616c25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28616c25",
  null
  
)

export default component.exports